import { jsx, jsxs } from "react/jsx-runtime";
import { useContext, useState } from "react";
import styled_components from "styled-components";
import { Badge, Box, Flex, IconButton, Tooltip } from "pcln-design-system";
import RealtimeHeaderIcon from "../../../svgs/RealtimeHeaderIcon.js";
import RealtimeWaveIcon from "../../../svgs/RealtimeWaveIcon.js";
import { InformationOutline } from "pcln-icons";
import { ChatbotDataContext } from "../../../context/ChatbotDataContext.js";
const StyledTooltip = /*#__PURE__*/ styled_components(Tooltip).withConfig({
    displayName: "RealTimeHeader__StyledTooltip"
})([
    "left:",
    ";width:",
    ";text-align:left;"
], ({ isMobile })=>isMobile ? '16px' : '-8px', ({ isMobile, isStandalone })=>isStandalone && isMobile ? '145px' : '300px');
const RealTimeHeader = ({ isStandalone })=>{
    const [isDisplayed, setTooltipDisplayState] = useState(false);
    const { isMobile } = useContext(ChatbotDataContext);
    const IconButtonProps = {
        ml: 2,
        id: 'openTooltipButton',
        'data-testid': 'openTooltipButton',
        title: 'open tooltip',
        onClick: (e)=>{
            e.preventDefault();
            setTooltipDisplayState(!isDisplayed);
        },
        icon: /*#__PURE__*/ jsx(InformationOutline, {
            size: 16
        })
    };
    return /*#__PURE__*/ jsxs(Flex, {
        alignItems: 'center',
        justifyContent: 'center',
        children: [
            /*#__PURE__*/ jsx(RealtimeHeaderIcon, {}),
            /*#__PURE__*/ jsx(Badge, {
                color: "primary",
                bg: "background.light",
                ml: 1,
                children: "BETA"
            }),
            /*#__PURE__*/ jsxs(Box, {
                mr: "0",
                color: 'white',
                children: [
                    /*#__PURE__*/ jsx(IconButton, {
                        ...IconButtonProps,
                        onClick: function() {
                            setTooltipDisplayState(!isDisplayed);
                        }
                    }),
                    isDisplayed && /*#__PURE__*/ jsxs(StyledTooltip, {
                        isStandalone: isStandalone,
                        bg: "background.darkest",
                        color: "background.lightest",
                        center: isMobile,
                        left: !isMobile,
                        isMobile: isMobile,
                        children: [
                            "Powered by OpenAI. Chat transcripts are recorded for quality review purposes. Penny can make mistakes. Please do not share any personal information in the chat.",
                            /*#__PURE__*/ jsx("br", {}),
                            /*#__PURE__*/ jsx("br", {}),
                            "\xa9 ",
                            new Date().getFullYear(),
                            " Priceline - Patent Pending"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsx(RealtimeWaveIcon, {})
        ]
    });
};
const RealTimeHeader_RealTimeHeader = RealTimeHeader;
export { RealTimeHeader_RealTimeHeader as default };
